import React, { useMemo } from "react";
import PropTypes from "prop-types";

import {
  HintComposer,
  Label,
  Money,
  Segment,
  StaticBulletList,
  Tooltip,
} from "..";

function PlanCard({
  id,
  name,
  featureList,
  upgradeablePlanOptions,
  eligibility,
  selected,
  isCurrent,
  onClick,
  reloadButton,
  onSuggestedHintClicked,
}) {
  const { currency, monthlyPrice } = useMemo(() => {
    return upgradeablePlanOptions?.[0]?.pricing || {};
  }, [upgradeablePlanOptions]);

  if (!id || !upgradeablePlanOptions?.length) return null;

  return (
    <Tooltip
      hoverable
      title={
        <HintComposer
          {...eligibility}
          reloadButton={reloadButton}
          onSuggestedHintClicked={onSuggestedHintClicked}
        />
      }
      hidden={eligibility.eligible}
    >
      <Segment
        raised
        data-test="plan-card"
        style={{
          background: "none",
          border: selected ? "1px solid #2185D0" : "",
          height: "100%",
        }}
        className="clickable grey_on_hover no_select"
        disabled={!eligibility.eligible}
        onClick={() => {
          if (eligibility.eligible && !selected) onClick(id);
        }}
      >
        {isCurrent && (
          <Label color="blue" ribbon="right">
            Current Plan
          </Label>
        )}
        <div
          style={{
            textAlign: "center",
            marginBottom: "1.8em",
            ...(isCurrent ? {} : { marginTop: "1.8em" }),
          }}
        >
          <StaticBulletList
            header={name}
            legend={
              <React.Fragment>
                <div style={{ fontWeight: "bold", fontSize: "130%" }}>
                  <Money currency={currency}>{monthlyPrice}</Money>
                </div>
                per user/month
              </React.Fragment>
            }
            items={featureList}
          />
        </div>
      </Segment>
    </Tooltip>
  );
}

PlanCard.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  featureList: PropTypes.arrayOf(PropTypes.string),
  upgradeablePlanOptions: PropTypes.array,
  eligibility: PropTypes.shape({
    eligible: PropTypes.bool,
    cause: PropTypes.string,
    suggestions: PropTypes.arrayOf(PropTypes.object),
  }),
  selected: PropTypes.bool,
  isCurrent: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  reloadButton: PropTypes.node,
  onSuggestedHintClicked: PropTypes.func,
};

PlanCard.defaultProps = {
  id: null,
  name: "",
  isCurrent: false,
  featureList: [],
  upgradeablePlanOptions: [],
  eligibility: { eligible: false, cause: "", suggestions: [] },
  selected: false,
  reloadButton: undefined,
  onSuggestedHintClicked: () => {},
};

export default PlanCard;
